import { useQuery } from 'react-query';
import { getAllThemes, getGradingLimitsList } from './gradingLimitsApis';

export enum GradingLimitsQueryKeys{
  GET_GRADE_LIST = 'getGradingLimitsList',
  GET_THEME_LIST = 'getThemeList',
}

export const useGradingLimitsList = () => (
  useQuery(GradingLimitsQueryKeys.GET_GRADE_LIST, async () => (await getGradingLimitsList()).data.data)
);

export const useThemeList = () => (
  useQuery(GradingLimitsQueryKeys.GET_THEME_LIST, async () => (await getAllThemes()).data.data)
);
